

export default async function (videoRef) {
  if (videoRef === undefined) {
    return;
  }
  try {
    await videoRef.play();
  } catch (error) {
    if (error.name === 'AbortError') {
      // Silently ignore AbortError where user pressed spacebar quickly,
      // leave other errors - they should be investigated.
      // See HUB-1872, HUB-1897 &
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play
      return;
    }
    throw error;
  }
}